(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Conexiones', Conexiones);

    Conexiones.$inject = ['$resource', 'DateUtils'];

    function Conexiones ($resource, DateUtils) {
        var resourceUrl =  'api/conexiones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.ultimafechaconexion = DateUtils.convertDateTimeFromServer(data.ultimafechaconexion);
                        data.ultimafechatx = DateUtils.convertDateTimeFromServer(data.ultimafechatx);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
